import React from 'react';
import { Analytics } from '@vercel/analytics/react';

export const AnalyticsWrapper = () => {
  // Only render Analytics in production
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }
  
  return <Analytics />;
};